import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { FILTER_VARIANT_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
}

const mutateAddFilterVariants = async ({
  data,
}: mutateProps) => {
  return await axiosAuth.post(`${FILTER_VARIANT_API}`, data);
};

const useAddFilterVariantsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddFilterVariants,
    ...queryParams,
  });

export default useAddFilterVariantsMutation;
